<button mat-flat-button (click)="back.emit()">
  <div class="inner-container">
    <oph-icon name="chevron-left-brown" [size]="13"></oph-icon>
    <span>BACK</span>
  </div>
</button>
